import { Injectable, Provider, Type } from '@angular/core';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

/**
 * `DialogService` with the app-wide dialog defaults (BDA-6419): every dialog is closable,
 * i.e. shows the × and closes on Escape. PrimeNG leaves `closable` unset, and its dialog
 * only binds Escape for closable dialogs. A dialog that must stay open passes
 * `closable: false` explicitly.
 */
@Injectable()
export class BdDialogService extends DialogService {
  // Same signature as PrimeNG's `open`, so every existing call site still type-checks.
  /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-object-type */
  public override open<
    T,
    DataType = any,
    InputValuesType extends Record<string, any> = {},
  >(
    componentType: Type<T>,
    config: DynamicDialogConfig<DataType, InputValuesType>,
  ): DynamicDialogRef<T> | null {
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-object-type */
    return super.open(componentType, {
      ...config,
      closable: config.closable ?? true,
    });
  }
}

/**
 * Use in place of `DialogService` in `providers` arrays; components keep injecting
 * `DialogService`.
 */
export const BD_DIALOG_SERVICE_PROVIDER: Provider = {
  provide: DialogService,
  useClass: BdDialogService,
};
